import { Product } from '../types/product'
import { getMinEffectivePrice } from './cartUtils'
import {
  SITE_NAME,
  SITE_ORIGIN,
  absoluteUrl,
  productCanonicalPath,
  productDescription,
} from './pageMeta'

export function productJsonLd(product: Product) {
  const price = getMinEffectivePrice(product.prices)
  const image = product.mainPictureBig || product.mainPicture

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: productDescription(product),
    image: image || undefined,
    sku: product.id,
    brand: {
      '@type': 'Organization',
      '@id': `${SITE_ORIGIN}/#organization`,
      name: SITE_NAME,
    },
    offers:
      price == null
        ? undefined
        : {
            '@type': 'Offer',
            url: absoluteUrl(productCanonicalPath(product.slug)),
            priceCurrency: 'UAH',
            price: price.toFixed(2),
            availability: 'https://schema.org/InStock',
          },
  }
}

export function breadcrumbListJsonLd(items: Array<{ path: string; name: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items
      .filter(item => item.path)
      .map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: absoluteUrl(item.path),
      })),
  }
}
